import { lazy } from 'react';

const EmployeeMasterList = lazy(() =>
  import('../pages/EmployeeDatabase/EmployeeMasterList/index'),
);
const PayrollMasterList = lazy(() =>
  import('../pages/EmployeeDatabase/PayrollMasterList/index'),
);

const employeeDatabaseRoute = {
  public: [],
  auth: [
    {
      name: 'employee_master_list',
      path: '/employee/employee-master-list',
      component: EmployeeMasterList,
    },
    {
      name: 'payroll_master_list',
      path: '/employee/payroll-master-list',
      component: PayrollMasterList,
    },
  ],
};

export default employeeDatabaseRoute;
